import { wssUrl } from "@/utils/basic";
import store from "@/store";
import { logout } from "@api/login";
import Cookies from "js-cookie";
import router from "@/router";
import { showWindowMessage } from "@utils/notification";

let timer = null;

// let reconnectDelay = 3000; // 重连延迟时间，单位：毫秒

export function getStream(dealAmbulanceStatus, setConnection, dealAmbulanceConnectStatus, that) {
  const ws = new WebSocket(wssUrl);
  ws.onopen = function() {
    store.commit("updateWebSocketClient", ws);
    const { userInfo: { token, id } } = store.state;
    const active = { // 获取活跃的任务事件
      token,
      type: "activeMedicalhistoryAll"
    };
    ws.send(JSON.stringify(active));
    const invite = { // 医生协助邀请
      id,
      "type": "assist_message",
      token,
    };
    ws.send(JSON.stringify(invite));
    const gps = { // gps数据
      token,
      type: "ambulance_gps_data"
    };
    ws.send(JSON.stringify(gps));

    const connectStatus = { // 急救车发车后连接状态
      token,
      type: "ambulance_connect_status"
    };
    ws.send(JSON.stringify(connectStatus));

    const ambulanceStatus = { // 所有急救车的发车状态
      token,
      from: "web",
      type: "all_ambulance_status"
    };
    ws.send(JSON.stringify(ambulanceStatus));

    const tencentRoomRollback = { // 最近一个小时内的房间状态
      token,
      type: "tencent_room_rollback"
    };
    ws.send(JSON.stringify(tencentRoomRollback));

    timer = setInterval(() => {
      const checkToken = { // 检查token有效期
        token,
        type: "check_token"
      };
      if (ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify(checkToken));
      }
    }, 1000 * 10);
  };

  ws.onmessage = function({ data: response }) {
    let jsonResponse;
    try {
      jsonResponse = JSON.parse(response);
    } catch (e) {
      console.log(e);
      return;
    }
    const { data, type, code, from } = jsonResponse;
    switch (type) {
      case "activeMedicalhistoryAll":
        data.forEach(
          (mission) => {
            const { turout_time, arrived_time, board_time, done_time } = mission;
            mission["_turout_time"] = turout_time?.split(" ")[1];
            mission["_arrived_time"] = arrived_time?.split(" ")[1];
            mission["_board_time"] = board_time?.split(" ")[1];
            mission["_done_time"] = done_time?.split(" ")[1];
          }
        );
        store.commit("updateCurrentList", data);
        break;
      case "assist_message":
        store.commit("updateAssistMessage", data);
        // console.log(data);
        break;
      case "ambulance_gps_data":
        try {
          // console.log(data);
          const carPositions = data;
          const mapData = {};
          // set the key -1 for update automatically (for watch )
          mapData[-1] = Date.now();
          carPositions.forEach(carPosition => {
            const { id, data } = carPosition;
            // 只有有data的车辆, 才会被保存起来, 其他的数据丢弃
            if (data) mapData[id] = data;
          });

          if (JSON.stringify(mapData) === "{}") {
            return false; // 如果为空,返回false
          }
          setConnection(mapData);
          store.commit("updateAllPosition", mapData);
        } catch (e) {
          console.log(e);
        }
        break;
      case "all_ambulance_status": // 急救车发车状态
        if (from === "web") {
          dealAmbulanceStatus(data);
        }
        break;
      case "ambulance_connect_status": // 急救车发车后连接状态
        dealAmbulanceConnectStatus(data);
        break;
      case "tencent_room_rollback": // 腾讯视频房间的回调函数
        console.log("---------------------room status ---");
        try {
          // 拿到来的data 是一个数组
          // const { roomId, operate } = data;
          console.log(data);
          data.forEach(room => {
            room.status = room.operate === "create";
          });
          // const status = operate === "create";
          store.commit("updateTencentRoomStatus", data);
        } catch (e) {
          console.log(e);
        }
        break;
      case "check_token":
        if (code !== 200) {
          showWindowMessage(2, "登录有效期失效，请重新登录！", that);
          clearInterval(timer);
          timer = null;
          logout();
          Cookies.remove("token");
          localStorage.removeItem("loginStatus");
          sessionStorage.clear();
          router.push("/login");
          store.commit("deleteData");
        }
        break;
      default:
        break;
    }
  };
  ws.onclose = () => {
    showWindowMessage(2, "与服务器的连接断开, 请刷新, 如持续出现此问题, 请联系后台人员", that);
  };
}
